const selectors = {
  global: {
    ACTIVE_COLOR_NAME: "active-color-name",
    ACTIVE_COLOR_SLIDE: ".js-color-variant-selector-active",
    COLOR_VARIANT_SELECTOR: ".js-color-variant-selector",
    CUTOFF: ".js-product-details-delivery-dates-cutoff",
    DATE_HIGHLIGHT: "product-details-quantity-form-row__actual-price--highlight",
    DELIVERY_DATES: ".js-continue-shopping-modal-delivery-dates",
    J1ST_ICON: ".product-details-delivery-date__icon-wrapper",
    MODAL_SHIPMENTS_LIST: ".js-continue-shopping-modal-delivery-dates-shipments",
    MODAL_DATES_CUTOFF: ".js-continue-shopping-modal-dates-cutoff",
    MODAL_SPINNER: ".js-continue-shopping-modal-delivery-dates-spinner",
    PRODUCT_PAGE_CONTAINER: "product-page-container",
    PRODUCT_DETAILS_VARIANT_FORM: "#product-details-variants-form"
  },
  local: {
    CONTAINER: "js-product-details-delivery-dates-simple-container",
    DIRECT_DELIVERY_DATE: ".js-product-details-delivery-dates-simple-direct-value",
    FORM_ERROR: ".js-delivery-date-form-error",
    FORM_INPUT: ".js-delivery-date-form-input",
    FORM: ".js-delivery-date-form",
    SPINNER: ".js-product-details-delivery-dates-simple-spinner",
    WRAPPER: ".js-product-details-delivery-dates-simple-wrapper"
  },
  made: {
    CONTAINER: "js-made-product-details-delivery-dates-simple-container",
    CUTOFF: ".js-made-product-details-delivery-dates-simple-cutoff",
    DIRECT_DELIVERY_DATE: ".js-made-product-details-delivery-dates-simple-direct-value",
    MODAL_SHIPMENTS_LIST: ".js-made-continue-shopping-modal-delivery-dates-shipments",
    MODAL_DATES_CUTOFF: ".js-made-continue-shopping-modal-dates-cutoff",
    SPINNER: ".js-made-product-details-delivery-dates-simple-spinner",
    WRAPPER: ".js-made-product-details-delivery-dates-simple-wrapper",
    FREE_SHIPPING_THRESHOLD: ".js-made-product-details-delivery-dates-simple-free-shipping-value"
  }
};

export default selectors;
